<mat-drawer-container style="height: 100%;">

  <!-- Liste des formes disponible -->
  <mat-drawer #drawerShape (openedChange)="onDrawerStateChange.emit($event)" class="drawer-container" mode="side" position="end" opened disableClose="true">
    <!--Drawer content liste des formes-->
    <app-list-forme
      [Shapes]="arrayShape"
      [FavoriteShapes]="arrayFavoriteShape"
      (mInputRepartition)="onDrawerInputRepartitionClick()"
      (mInputShape99)="openShape99()"
      (onShapeClick)="onDrawerShapeClick($event)"
      (onMeshClick)="onMeshClick()"
      [disabled]="isReadOnlyOrLock"></app-list-forme>
  </mat-drawer>

  <mat-drawer-content id="decorticage-content" >
    <!-- ---------------------- -->
    <!-- Contenu du décorticage -->
    <!-- ---------------------- -->
    <div class="armabox" style="max-height: 100%">
      <!-- header deco -->
      <div class="armarow header">
        <div class="mat-elevation-z8 center-elem-lmargin input-content medium-border-arma-color">
          <mat-expansion-panel #panelInfoOrder
                               (opened)="onPanelOrderInfoStateChange(panelInfoOrder)"
                               (closed)="onPanelOrderInfoStateChange(panelInfoOrder)">

            <mat-expansion-panel-header>
              <mat-panel-title>{{'Informations du contrat' | translate}}</mat-panel-title>
              <mat-panel-title class="error-header" *ngIf="!isHeaderValid" >{{'Informations obligatoires requises' | translate}}</mat-panel-title>
              <mat-panel-title class="error-header" *ngIf="HTML_ReadOnlyAnalysis" >{{'Lecture seule' | translate}}</mat-panel-title>
              <mat-panel-title>{{'Poids Total' | translate}} {{HTML_AnalysisTotalWeight | number: '1.0-2'}} {{'kg' | translate}}</mat-panel-title>
              <mat-panel-description> {{'Cliquer pour' | translate}} {{mPanelOrderInfoOpenState ? ('réduire' | translate) : ('développer' | translate) }} </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="header-deco">

              <div class="h-left-side">

                <div>
                  <label class="hl-text">{{'Désignation' | translate}}</label>
                  <input class="hl-data" type="text" #taDesignation
                    id="id-designation"
                    autocomplete="off"
                    (keypress)="blockTextEvent($event)"
                    (keyup)="onOrderInfoKeyPress($event)"
                    [disabled]="isReadOnlyOrLock"
                    (focusout)="backupAnalysis()"
                    maxlength="100">
                </div>

                <div>
                  <label class="hl-text">{{'N ° de Plan' | translate}}</label>
                  <input class="hl-data" type="text" #taNumplan
                    id="id-numplan"
                    autocomplete="off"
                    (keypress)="blockTextEvent($event)"
                    (keyup)="onOrderInfoKeyPress($event)"
                    [disabled]="isReadOnlyOrLock"
                    (focusout)="backupAnalysis()"
                    maxlength="100">
                </div>

                <div>
                  <label class="hl-text">{{'Commentaire' | translate}}</label>
                  <input class="hl-data" type="text" #inputVarious
                    id="in-various"
                    autocomplete="off"
                    (keyup)="onOrderInfoKeyPress($event)"
                    [disabled]="isReadOnlyOrLock"
                    (focusout)="backupAnalysis()"
                    maxlength="150">
                </div>

                <div [ngClass]="{'error-field': !isDeliveryDateValid}">
                  <label class="hl-text">{{'Date de livraison' | translate}}*</label>
                  <armaDateTimePicker class="hl-data" #armDatePicker
                                      [lockDayBeforeToday]="true"
                                      [lockOpenDayAfterToday]="nbLockAfterToday"
                                      [disabled]="isReadOnlyOrLock"
                                      (dateChange)="backupAnalysis()">
                  </armaDateTimePicker>
                </div>

                <div [ngClass]="{'error-field': !isCustomerRefValid}">
                  <label class="hl-text">{{'Référence client' | translate}}*</label>
                  <input class="hl-data" type="text" #inputCustRef
                         id="in-cust-ref"
                         autocomplete="off"
                         (keyup)="onOrderInfoKeyPress($event)"
                         [disabled]="isReadOnlyOrLock"
                         (focusout)="backupAnalysis()"
                         maxlength="150">
                </div>

                <div>
                  <label class="hl-text">{{'Chantier' | translate}}</label>
                  <site-selector class="hl-data" #decoSiteSelect [disabled]="isReadOnlyOrLock" (onSiteCodeChange)="onSiteCodeChange($event)"></site-selector>
                </div>

                <div [ngClass]="{'error-field': !isContactValid}">

                  <label class="hl-text">{{'Contact' | translate}}</label>

                  <div class="hl-data header-deco-contact">
                    <ng-container *ngIf="contactInformation; then thenContact else elseContact"></ng-container>
                    <ng-template #thenContact>

                      <div>{{contactInformation.Name}} {{contactInformation.LastName}}</div>
                      <button mat-icon-button [disabled]="isReadOnlyOrLock" (click)="onBtnContactClick()">
                        <mat-icon>menu</mat-icon>
                      </button>
                      <button mat-icon-button color="warn" [disabled]="isReadOnlyOrLock" (click)="onBtnContactRemove()">
                        <mat-icon>close</mat-icon>
                      </button>

                    </ng-template>
                    <ng-template #elseContact>

                      <button mat-button [disabled]="isReadOnlyOrLock" (click)="onBtnContactClick()">
                        {{'Sélectionner un contact' | translate}}
                      </button>

                    </ng-template>
                  </div>

                </div>

                <div>
                  <label class="hl-text">{{'Note' | translate}}</label>
                  <div class="hl-data">
                    <button mat-button [disabled]="isAnalysisLocked" (click)="onBtnNoteClick()">
                      <mat-icon>note</mat-icon>
                      {{(HTML_ReadOnlyAnalysis ? 'Voir les notes' : 'Modifier les notes') | translate}}
                    </button>
                  </div>
                </div>

              </div>

              <div class="h-right-side" (click)="inputSelectFile.click()">
                <div *ngIf="!isReadOnlyOrLock" type="button" style="text-align: center; cursor: pointer;">{{'Cliquer ou déposer un fichier' | translate}}</div>
                <input hidden #inputSelectFile [disabled]="isReadOnlyOrLock" (change)="onFileSelected($event)" type="file" multiple />
                <div class="div-list-file">
                  <table>
                    <tr *ngFor="let file of arrayAnalysisFile; let i=index;">
                      <td colspan="2" style="overflow-wrap: anywhere;">{{file.fileName}}</td>
                      <td colspan="1" *ngIf="file.inProgress"><mat-spinner [diameter]="15"></mat-spinner></td>
                      <td colspan="1" *ngIf="!isReadOnlyOrLock" (click)="removeFile($event, i)" style="cursor: pointer; user-select: none; color: red;">X</td>
                    </tr>
                  </table>
                </div>
              </div>

            </div>

            <table class="info-dec-2-row">
            </table>

          </mat-expansion-panel>
        </div>
        <mat-progress-bar class="center-elem-lmargin" style="width: auto;" *ngIf="HTML_LockAnalysis" mode="indeterminate"></mat-progress-bar>
      </div>
      <!-- fin header -->

      <div id="div-first-add" *ngIf="showBtnAddProductOrSteel" class="armarow content center-elem-lmargin">
        <button mat-raised-button color="primary" class="button-x-large" (click)="startWith('steel')">{{'Commande d\'acier'|translate}}</button>
        <button mat-raised-button color="primary" class="button-x-large" (click)="startWith('prod')">{{'Commande de produit standard'|translate}}</button>
      </div>

      <!-- Tableau du deco -->
      <mat-expansion-panel #panelAnalysis
                           [ngClass]="{'hide-div': !displayPanelAnalysis}"
                           (opened)="onPanelOrderInfoStateChange(panelAnalysis)"
                           (closed)="onPanelOrderInfoStateChange(panelAnalysis)"
                           style="display: flex; flex-direction: column; margin: 0.2% 5%;"
                           class="armarow content mat-elevation-z8 medium-border-arma-color no-panel-padding panel-scroll-content-full">

        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'Décorticage' | translate }}
          </mat-panel-title>
          <mat-panel-title>
            {{'Poids'|translate}} {{HTML_AnalysisWeight | number: '1.0-2'}} {{'kg' | translate}}
          </mat-panel-title>
          <mat-panel-description>
            {{'Cliquer pour'|translate}} {{panelAnalysis.expanded ? ('réduire'|translate) : ('développer'|translate) }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <table mat-table #tableDec id="table"
               (keyup)="onKeyUp($event)"
               (keydown)="onTableKeyDown($event)"
               [dataSource]="dataSource"
               style="width: 100%;"
               class="cmat-add-border">

          <!-- Position Column -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.IdLine">
            <th class="table-x-small-width-fixed" #colHeaderIdLine mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let element">
              <!-- {{element.cDecLineType}} --> <!-- Pour debug, aide a identifier le type de ligne -->
              <ng-container *ngIf="HTML_isLineValide(element); else ErrorLineTemplate">{{asLineDec(element).mNoLine}}</ng-container>
              <ng-template #ErrorLineTemplate>
                <!-- Btn pour afficher l'erreur sur la ligne -->
                <button #tooltip="matTooltip" mat-mini-fab color="warn"
                        [matTooltip]="getErrorLineDec(element, false)"
                        matTooltipPosition="after"
                        matTooltipHideDelay="2000"
                        aria-label="error"
                        [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.IdLine)"
                        (click)="getErrorLineDec(element, true)">
                  <mat-icon>priority_high</mat-icon>
                </button>
              </ng-template>
            </td>
          </ng-container>

          <!-- Member name -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Membername">
            <th #colHeaderMemberName mat-header-cell *matHeaderCellDef> {{'Nom de l\'élément' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="asLineDec(element).cDecLineType">
                <div *ngSwitchDefault>
                  <input autocomplete="off"
                         [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.Membername, asLineDec(element).mNoLine)"
                         class="tab-input"
                         (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                         [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Membername)"
                         [(ngModel)]="asLineDec(element).mMemberName">
                </div>
                <div *ngSwitchCase="'Distribution'">
                  <arma-repartition
                    width="250"
                    height="100"
                    id="{{asLineDec(element).mNoLine}}"
                    [Repartition]="asLineDec(element).mRepartition"
                    (InputFocus)="onInputFocus($event, asLineDec(element).mNoLine)">
                  </arma-repartition>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Length -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Length">
            <th class="table-medium-width-fixed" mat-header-cell *matHeaderCellDef> {{'Longueur' | translate}} </th>
            <td mat-cell *matCellDef="let element" >
              <div *ngIf="asLineDec(element).isAShape() || asLineDec(element).isAShape99()">
                {{asLineDec(element).mLongClient}}
              </div>
            </td>
          </ng-container>

          <!-- Bar mark -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Barmark">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> {{'REP' | translate}} </th>
            <td mat-cell *matCellDef="let element" >
              <ng-container [ngSwitch]="asLineDec(element).cDecLineType">
                <input *ngSwitchDefault
                       class="tab-input"
                       autocomplete="off"
                       [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.Barmark, asLineDec(element).mNoLine)"
                       (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                       [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Barmark)"
                       [(ngModel)]="asLineDec(element).mBM">

                <div *ngSwitchCase="'WMesh'">
                  {{asLineDec(element)?.wMeshInformation.barmark}}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Qty -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Qty">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> {{'Qte' | translate}} </th>
            <td mat-cell *matCellDef="let element" >
              <ng-container [ngSwitch]="asLineDec(element).cDecLineType">
                <input *ngSwitchDefault
                       autocomplete="off"
                       (keypress)="keyPressOnlyNumber($event)"
                       [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.Qty, asLineDec(element).mNoLine)"
                       (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                       (focusout)="focusOutCheckNumberOrClear($event.target)"
                       class="tab-input"
                       [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Qty)"
                       [(ngModel)]="asLineDec(element).mQty">

                <div *ngSwitchCase="'WMesh'">
                  {{asLineDec(element)?.wMeshInformation.quantity}}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Diameter -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Diameter">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> {{'Diam.' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="asLineDec(element).cDecLineType">
                <filterable-input *ngSwitchDefault
                                  [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.Diameter, asLineDec(element).mNoLine)"
                                  [autocompleteValue]="GetAvailableDiameters(element)"
                                  [disabledInput]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Diameter)"
                                  [(inputModel)]="asLineDec(element).mDiamNum"
                                  (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                                  (focusout)="checkDiam(element)"
                                  (keypress)="keyPressOnlyNumberFloat($event)"
                                  (change)="checkDiam(element)">
                </filterable-input>

                <div *ngSwitchCase="'WMesh'">
                  <div>X: {{(asLineDec(element)?.wMeshInformation.horizontal.diameter | splitDiamGrade)[0]}}</div>
                  <div>Y: {{(asLineDec(element)?.wMeshInformation.vertical.diameter | splitDiamGrade)[0]}}</div>
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Grade -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Grade">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> {{'Nuance' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="asLineDec(element).cDecLineType">
                <ng-container *ngSwitchDefault>
                  <select *ngIf="!(asLineDec(element).isARepartition())" [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Grade)"
                          class="no-background"
                          style="width: 50px"
                          [value]='asLineDec(element).mDiamGrade'
                          [(ngModel)]="asLineDec(element).mDiamGrade">
                    <ng-container *ngFor="let item of GetAvailableGrades(element)">
                      <option value="{{item.Code}}">{{item.Code}} - {{item.Name}}</option>
                    </ng-container>
                  </select>
                </ng-container>

                <div *ngSwitchCase="'WMesh'">
                  <div>{{(asLineDec(element)?.wMeshInformation.horizontal.diameter | splitDiamGrade)[1]}}</div>
                  <div>{{(asLineDec(element)?.wMeshInformation.vertical.diameter | splitDiamGrade)[1]}}</div>
                </div>
              </ng-container>

            </td>
          </ng-container>

          <!-- Shape code -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.IdShape">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> {{'Code forme' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="asLineDec(element).cDecLineType">
                <input *ngSwitchDefault
                       autocomplete="off"
                       maxlength="4"
                       [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.IdShape, asLineDec(element).mNoLine)"
                       (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                       class="tab-input"
                       [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.IdShape)"
                       [(ngModel)]="asLineDec(element).mCodeF"
                       (ngModelChange)="onCodeFormeChange(element, $event)">

                <div *ngSwitchCase="'WMesh'" class="unselectable">{{'Treillis' | translate}}</div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Pour le  BS 4466 / 8666 il faut afficher les cotes des formes -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.A">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> A </th>
            <td mat-cell *matCellDef="let element">
              <input autocomplete="off"
                     [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.A, asLineDec(element).mNoLine)"
                     (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                     class="tab-input no-arrow"
                     [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.A) || asLineDec(element).isAShape99() || isCoteLocked(element, 0)"
                     [(ngModel)]="asLineDec(element).mArrayCote[0]">
            </td>
          </ng-container>

          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.B">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> B </th>
            <td mat-cell *matCellDef="let element">
              <input autocomplete="off"
                     [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.B, asLineDec(element).mNoLine)"
                     (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                     class="tab-input"
                     [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.B) || asLineDec(element).isAShape99() || isCoteLocked(element, 1)"
                     [(ngModel)]="asLineDec(element).mArrayCote[1]">
            </td>
          </ng-container>

          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.C">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> C </th>
            <td mat-cell *matCellDef="let element">
              <input autocomplete="off"
                     [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.C, asLineDec(element).mNoLine)"
                     (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                     class="tab-input"
                     [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.C) || asLineDec(element).isAShape99() || isCoteLocked(element, 2)"
                     [(ngModel)]="asLineDec(element).mArrayCote[2]">
            </td>
          </ng-container>

          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.D">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> D </th>
            <td mat-cell *matCellDef="let element">
              <input autocomplete="off"
                     [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.D, asLineDec(element).mNoLine)"
                     (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                     class="tab-input"
                     [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.D) || asLineDec(element).isAShape99() || isCoteLocked(element, 3)"
                     [(ngModel)]="asLineDec(element).mArrayCote[3]">
            </td>
          </ng-container>

          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.E_R">
            <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> E/R </th>
            <td mat-cell *matCellDef="let element">
              <input autocomplete="off"
                     [id]="getHtmlInputWithColnameNoline(HTML_ANALYSIS_COL.E_R, asLineDec(element).mNoLine)"
                     (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                     class="tab-input"
                     [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.E_R) || asLineDec(element).isAShape99() || isCoteLocked(element, 4)"
                     [(ngModel)]="asLineDec(element).mArrayCote[4]">
            </td>
          </ng-container>
          <!-- Fin cote pour le bs -->

          <!-- Dessin de la forme ici -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Schema">
            <th #colHeaderSchema class="table_schema" mat-header-cell *matHeaderCellDef>
              {{'Schéma' | translate}}<br>
              {{'Côtes en' | translate}} {{HTML_LenghtMeasure | translate}}
            </th>
            <td mat-cell *matCellDef="let element" >
              <ng-container [ngSwitch]="asLineDec(element).cDecLineType">
                <div *ngSwitchDefault class="div-canvas-input" id="canvas-and-input">
                  <arma-shape
                    [shape]="getFormeFromCatalogue(asLineDec(element).mCodeF)"
                    [shape99]="asLineDec(element).mInfoShape99"
                    [wmesh]="asLineDec(element).wMeshInformation"
                    [disabledInput]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Schema)"
                    [filantRepart]="asLineDec(element).mFilantRepart"
                    width="250"
                    height="100"
                    [HighlightMeasureId]="getHighlightMeasureId(asLineDec(element).mNoLine)"
                    id="{{asLineDec(element).mNoLine}}"
                    [ArrayCote]="asLineDec(element).mArrayCote"
                    (InputFocus)="onInputFocus($event, asLineDec(element).mNoLine)">
                  </arma-shape>
                  <div class="input-little-comment">{{asLineDec(element).mSmallComment}}</div>
                </div>
                <div *ngSwitchCase="'Distribution'" class="div-canvas-input-full" style="height: 100%;">
                  <input [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Schema)"
                         class="input-repartition"
                         id="{{getHtmlInputWithColnameNoline('Distribution', asLineDec(element).mNoLine)}}"
                         (change)="onRepartitionChanged(element, $event)"
                         (focus)="onInputFocus($event, element.mNoLine)"
                         type="text"
                         placeholder="{{'Répartition' | translate}}"
                         style="font-size: 16px; resize: none; text-align: justify;"
                         [(ngModel)]="asLineDec(element).mRepartition">
                </div>
              </ng-container>
            </td>
          </ng-container>

          <!-- Commentaire de la ligne -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Comment">
            <th class="table-medium-width-fixed" mat-header-cell *matHeaderCellDef>{{'Commentaire' | translate}}</th>
            <td mat-cell *matCellDef="let element">
              <textarea autocomplete="off"
                        class="tab-input no-scoll-bar"
                        maxlength="100"
                        cols="1"
                        rows="1"
                        style="resize: none; height: 90%"
                        (keydown)="noEnterTextArea($event)"
                        (focus)="onInputFocus($event, asLineDec(element).mNoLine)"
                        [disabled]="isReadOnlyOrLockCol(element, HTML_ANALYSIS_COL.Comment)"
                        [(ngModel)]="asLineDec(element).mSmallComment"
              ></textarea>
            </td>
          </ng-container>

          <!-- Sur la même ligne -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.Weight">
            <th class="table-medium-width-fixed" mat-header-cell *matHeaderCellDef> {{'Poids' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <div>{{asLineDec(element).getWeight()}}</div>
            </td>
          </ng-container>

          <!-- Comment -->
          <ng-container [matColumnDef]="HTML_ANALYSIS_COL.RealShapeDrawing">
            <th class="table-medium-width-fixed" mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element"
                (mouseenter)="utilitShapeDrawing.startDelayDisplayRealShapeDrawing($event, element, arrayShape, mGradeManager.GetArrayDiameter())"
                (mousemove)="utilitShapeDrawing.updatePoseRealShapeDrawing($event)"
                (mouseleave)="utilitShapeDrawing.cancelDisplayRealShapeDrawing()"
            >
              <img height="32px" src="assets/icons/view.png" alt="real shape">
            </td>
          </ng-container>

          <!-- Config du mat table -->
          <tr mat-header-row
              class="armaor-background-color tr-header"
              style="font-size: medium"
              *matHeaderRowDef="displayedColumns; sticky: true">
          </tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
              id="ana-line-{{asLineDec(row).mNoLine}}"
              [ngClass]="getNGClassLine(row)"
              (click)="onColFocus($event, asLineDec(row).mNoLine)"
              (dblclick)="onDblClick(row)"
              (contextmenu)="onRightClick($event, asLineDec(row).mNoLine, menuTrigger)"
              (change)="onValueLineChange(row)">
          </tr>
        </table>

        <button mat-stroked-button
                *ngIf="!isReadOnlyOrLock"
                (click)="ajouterLigneDec()"
                class="btn-add-line-dec">{{'Ajouter une ligne'|translate}}</button>

      </mat-expansion-panel>
      <!-- fin tableau deco -->

      <!-- Tableau des produits standards -->
      <div class="mat-elevation-z8 center-elem-lmargin input-content medium-border-arma-color" [ngClass]="{'hide-div': !displayPanelProduct}">
        <mat-expansion-panel #panelProduct
                             (opened)="onPanelOrderInfoStateChange(panelProduct)"
                             (closed)="onPanelOrderInfoStateChange(panelProduct)" >
          <mat-expansion-panel-header>
            <mat-panel-title>{{'Produit Standard'|translate}}</mat-panel-title>
            <mat-panel-title>{{'Poids'|translate}} {{HTML_ProductWeight | number: '1.0-2'}} {{'kg' | translate}} </mat-panel-title>
            <mat-panel-description>{{'Cliquer pour'|translate}} {{panelProduct.expanded ? ('réduire'|translate) : ('développer'|translate)}}</mat-panel-description>
          </mat-expansion-panel-header>
          <button *ngIf="!isReadOnlyOrLock" mat-raised-button (click)="openProductInput()">{{'Ajouter Produit' | translate}}</button>
          <div class="armarow content">
            <table  (keydown)="onTableKeyDown($event)"
              id="table-product"
              mat-table
              #tableProduct
              [dataSource]="dataProduct"
              class="mat-elevation-z8 medium-border-arma-color cmat-add-border">

              <!-- Position Column -->
              <ng-container [matColumnDef]="HTML_PRODUCT_COL.IdLine">
                <th style="min-width: 50px;"
                    mat-header-cell
                    *matHeaderCellDef
                    class="table-small-width-fixed">#</th>
                <td style="min-width: 50px;"
                  mat-cell
                  *matCellDef="let product"
                  class="table-small-width-fixed">
                  {{product.mNoLine}}
                </td>
              </ng-container>

              <!-- Libellé de produit -->
              <ng-container [matColumnDef]="HTML_PRODUCT_COL.ProductLabel">
                <th mat-header-cell *matHeaderCellDef style="min-width: 250px;">{{'Libellé' | translate}}</th>
                <td mat-cell *matCellDef="let product">
                  {{product.mLabel}}
                </td>
              </ng-container>

              <!-- Qté de produit -->
              <ng-container [matColumnDef]="HTML_PRODUCT_COL.Qty">
                <th mat-header-cell *matHeaderCellDef class="table-medium-width-fixed">{{'Qte' | translate}}</th>
                <td mat-cell *matCellDef="let product" class="table-medium-width-fixed">
                  <input autocomplete="off"
                    type="text"
                    (keypress)="numberOnly($event)"
                    class="tab-input"
                    [disabled]="isReadOnlyOrLockCol(product, HTML_PRODUCT_COL.Qty)"
                    [(ngModel)]="product.mQty">
                </td>
              </ng-container>

              <!-- Unité principale du produit -->
              <ng-container [matColumnDef]="HTML_PRODUCT_COL.Unit">
                <th class="table-small-width-fixed" mat-header-cell *matHeaderCellDef> {{'Unité' | translate}} </th>
                <td class="table-small-width-fixed" mat-cell *matCellDef="let product" >{{product.mUnitUsed}}</td>
              </ng-container>

              <!-- Poids du produit -->
              <ng-container [matColumnDef]="HTML_PRODUCT_COL.Weight">
                <th class="table-medium-width-fixed" mat-header-cell *matHeaderCellDef> {{'Poids' | translate}} </th>
                <td class="table-medium-width-fixed" mat-cell *matCellDef="let product">
                  {{asProduct(product).totalWeight | number: '1.0-2'}} {{'kg' | translate}}
                </td>
              </ng-container>

              <tr mat-header-row
                class="armaor-background-color tr-header"
                *matHeaderRowDef="displayedProductColumns; sticky: true">
              </tr>
              <tr mat-row
                *matRowDef="let row; columns: displayedProductColumns;"
                id="ana-line-{{row.mNoLine}}"
                [ngClass]="getNGClassLine(row)"
                (contextmenu)="onRightClick($event, row.mNoLine, menuTrigger)"
                (change)="onValueLineChange(row)">
              </tr>
            </table>
          </div>
        </mat-expansion-panel>
      </div>
    </div>

  </mat-drawer-content>
</mat-drawer-container>

<!-- Forme à l'echele recuperer depuis armaor -->
<img #hoverRealShapeDrawing
     class="realShapeDrawing"
     (mouseenter)="utilitShapeDrawing.displayImg()"
     (mousemove)="utilitShapeDrawing.updatePoseRealShapeDrawing($event)"
     (mouseleave)="utilitShapeDrawing.hideImg()"
     (click)="utilitShapeDrawing.hideImg()"
     [src]="utilitShapeDrawing.shapeUrl"
     alt="real shape drawing">
<canvas #hoverMeshDrawing
        class="realShapeDrawing"
        (mouseenter)="utilitShapeDrawing.displayImg()"
        (mousemove)="utilitShapeDrawing.updatePoseRealShapeDrawing($event)"
        (mouseleave)="utilitShapeDrawing.hideImg()"
        (click)="utilitShapeDrawing.hideImg()"
        alt="real mesh drawing"></canvas>

<!-- Menu lors clique droit sur ligne -->
<span #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="contextMenu" class="context-menu-trigger"
  [style.left.px]="HTML_RightClickMenuPosX" [style.top.px]="HTML_RightClickMenuPosY"></span>
<mat-menu #contextMenu="matMenu" [ngSwitch]="getContextMenuType()">
  <div *ngSwitchCase="'line'">
    <button *ngIf="isContextMenuVisible('copy')"        [disabled]="isReadOnlyOrLock" (click)="HTML_copyLine()" mat-menu-item>{{'Copier' | translate}}</button>
    <button *ngIf="isContextMenuVisible('paste')"       [disabled]="isReadOnlyOrLock || !lineCopied" (click)="HTML_pasteLine()" mat-menu-item>{{'Coller' | translate}}</button>
    <button *ngIf="isContextMenuVisible('insert')"      [disabled]="isReadOnlyOrLock || !HTML_CanInsertLine()" (click)="HTML_InsertLine()" mat-menu-item>{{'Insérer' | translate}}</button>
    <button *ngIf="isContextMenuVisible('erase')"       [disabled]="isReadOnlyOrLock" (click)="HTML_eraseSelectedLine()" mat-menu-item>{{'Effacer' | translate}}</button>
    <button *ngIf="isContextMenuVisible('delete')"      [disabled]="isReadOnlyOrLock" (click)="HTML_DeleteLine()" mat-menu-item>{{'Supprimer' | translate}}</button>
    <button *ngIf="isContextMenuVisible('removeEmpty')" [disabled]="isReadOnlyOrLock" (click)="removeEmptyLine()" mat-menu-item>{{'Supprimer les lignes vides' | translate}}</button>
  </div>
  <div *ngSwitchCase="'affecteRepartition'">
    <button [disabled]="isReadOnlyOrLock" *ngIf="getSelectedLine() != null && getSelectedLine().mFilantRepart > 0"
        (click)="getSelectedLine().mFilantRepart = 0"
        mat-menu-item>
        {{'Dissocier ce filant de ces répartitions' | translate}}</button>
    <mat-checkbox
        [disabled]="isReadOnlyOrLock"
        class="mat-menu-item"
        *ngFor="let repartition of listRepartitionLine"
        [class.mat-checkbox-checked]="isRepartitionLinked(getRepartitionIndex(repartition), getSelectedLine())"
        (click)="toggleRepartition(getRepartitionIndex(repartition), getSelectedLine())">
        {{repartition.mRepartition}}
      </mat-checkbox>
  </div>
  <div *ngSwitchCase="'repartition'">
      <button
          [disabled]="isReadOnlyOrLock"
          (click)="distributionSymmetry(getSelectedLine())"
          mat-menu-item>
          {{'Symétrie répartition' | translate}}
      </button>
      <mat-checkbox
          [disabled]="isReadOnlyOrLock"
          class="mat-menu-item"
          (click)="toggleCrochetLevage(getSelectedLine())"
          [class.mat-checkbox-checked]="getSelectedLine().mRepartCrochetLevage">
          {{'Répartition de crochet de levage' | translate}}
      </mat-checkbox>
  </div>
</mat-menu>
